import { DeleteTeflCommentsRequest } from '../../../lib/types/models/tefl/tefl'
import { IdsInput } from '../../../lib/types/utils'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function deleteTeflLecComments(input: DeleteTeflCommentsRequest) {
  const { ids, teflId } = input
  return restApiClient
    .url(
      encodeNestedObject<IdsInput>(
        constructApiUrl(API.tefl.deleteTeflLecComments.url, { teflId }),
        { ids }
      )
    )
    .delete()
}
